export const MediaContentType = {
  MicBreak: 'MicBreak',
  Music: 'Music',
  News: 'News',
  Interview: 'Interview',
  Combo: 'Combo', //Should be renamed to 'Mixed', used for 'default' MediaTitles...
};
export type MediaContentTypes =
  (typeof MediaContentType)[keyof typeof MediaContentType];

export const SegmentType = {
  Studio: 'Studio',
  LiveSet: 'LiveSet',
  Story: 'Story',
};
export type SegmentTypes = (typeof SegmentType)[keyof typeof SegmentType];

export const LicensingKlass = {
  Dmca: 'Dmca',
  Direct: 'Direct',
};
export type LicensingKlasses =
  (typeof LicensingKlass)[keyof typeof LicensingKlass];

export const ProgramKlass = {
  BroadcastProgram: 'BroadcastProgram',
  Artist: 'Artist',
  Podcast: 'Podcast',
};
export type ProgramKlasses = (typeof ProgramKlass)[keyof typeof ProgramKlass];

// Mixes
// Primary type of content/purpose of the mix
// This can then be used in the playlist to control what is displayed
export const MixMediaType = {
  BROADCAST_MIX: 'BroadcastMix', // The original 'Remix' of broadcast segments
  BROADCAST_ARCHIVE: 'BroadcastArchive', // Sequentially played broadcast archive
  LIVE_SESSION: 'LiveSession',
  STORY: 'Story',
  INTERVIEW: 'Interview',
  PODCAST: 'Podcast',
};
export type MixMediaTypes = (typeof MixMediaType)[keyof typeof MixMediaType];

export const MixFilterKlass = {
  STATIC: 'StaticFilter', // Path defines the channel's filter
  DYNAMIC: 'DynamicFilter', // User can select what to filter based on the criteria in the
  SHOW_LIST: 'ShowList', // Items listed in the mix_show_items
  SEGMENT_LIST: 'SegmentList', // Items listed in mix_segment_items
};
export type MixFilterKlasses =
  (typeof MixFilterKlass)[keyof typeof MixFilterKlass];

export const MixPlaybackType = {
  CONTINUOUS: 'Continuous', // continuously play the segment - allowed to wrap around and start over
  TIMED: 'Timed', // Play the given duration of content and then move on
  PLAY_ALL: 'PlayAll', // Play all the content and then move on
  PLAY_X: 'PlayX', // Play X segments of content and then move on
  CONSTRAINED: 'Constrained'
};
export type MixPlaybackTypes =
  (typeof MixPlaybackType)[keyof typeof MixPlaybackType];

export const MixMicBreakMode = {
  ON: 10, // Initially On
  ALWAYS_ON: 20, // Always On, user can't turn off
  OFF: 100, // Initially Off
  ALWAYS_OFF: 110, // Always Off
};
export type MixMicBreakModes =
  (typeof MixMicBreakMode)[keyof typeof MixMicBreakMode];

export const PlaybackStatus = {
  PENDING: 0, // Scheduled, but not yet queued to play
  MEDIA_PLAYING: 5, // Media item is playing, but no indication the actual piece of content has started playing yet (for smart speakers...)
  LAST_MEDIA_PLAYING: 6, // Last media item in the ScheduleLog playing (set when we are scheduling the next before this one is done playing)
  PLAYING: 10, // Content is confirmed currently playing
  PLAYED: 100, // Content is confirmed played
  SKIPPED: -10, // Content was skipped
};

export const SchedulingKlasses = {
  SequentialSegmentScheduler: 'SequentialSegmentScheduler',
  ShowScheduler: 'ShowScheduler',
  ShowSegmentScheduler: 'ShowSegmentScheduler',
  RandomShowScheduler: 'RandomShowScheduler',
  RandomSegmentScheduler: 'RandomSegmentScheduler',
  RandomShowListScheduler: 'RandomShowListScheduler',
};
export type SchedulingKlass =
  (typeof SchedulingKlasses)[keyof typeof SchedulingKlasses];

/**
 * What to do when a show based mix finishes playing, and there is nothing queued up next
 */
export const PlayerAutoPlayModes = {
  OFF: 0,             // Autoplay is off
  NEXT_BROADCAST: 1,  // Move to the show that was broadcast after the currently playing show
  PREV_EPISODE: 2,    // Move to the previous show for this program
  RANDOM_SHOW: 3,     // Choose a random show
};
export type PlayerAutoPlayMode =
  (typeof PlayerAutoPlayModes)[keyof typeof PlayerAutoPlayModes];

export const EmailType = {
  ListenerLink: 'ListenerLink',
  MusicOfInterest: 'MOI'
};
export type EmailTypes = (typeof EmailType)[keyof typeof EmailType];
